// Get Lookbook Summary
export const GET_LOOKBOOK_SUMMARY_REQUEST = 'GET_LOOKBOOK_SUMMARY_REQUEST';
export const GET_LOOKBOOK_SUMMARY_DONE = 'GET_LOOKBOOK_SUMMARY_DONE';
export const GET_LOOKBOOK_SUMMARY_FAILED = 'GET_LOOKBOOK_SUMMARY_FAILED';
export const GET_LOOKBOOK_SUMMARY_RESET = 'GET_LOOKBOOK_SUMMARY_RESET';
